import { useEffect, useState, CSSProperties, useRef } from "react";

import { View, Text, StyleSheet, Pressable } from "react-native";
import { useNavigate } from "react-router";

import { ReactComponent as AccountSettingImg } from "../../../img/ico-contents-setting.svg";
import { ReactComponent as LogoutImg } from "../../../img/ico-contents-logout.svg";
import { ReactComponent as RootUserIcon } from "../../../img/ico-login-user.svg";
import { ReactComponent as DomainAdminIcon } from "../../../img/ico-login-domain.svg";
import { ReactComponent as SuperAdminIcon } from "../../../img/ico-login-admin.svg";
import { ReactComponent as RedirectIcon } from "../../../img/ico-prefix-redir.svg";
import { ReactComponent as RedirectGrayIcon } from "../../../img/ico-prefix-redir-gray.svg";

import { requests } from "../../../common/RestAPI";
import { base64Decoding, clearSessionStorage } from "../../../common/util";
import { FONT, SESSIONSTORAGE } from "../../../value/staticValues";
import { PAGE_URL, PLATFORM_URL } from "../../../value/Url";
import { useTranslation } from "react-i18next";

function CommonProfile() {
  const loggedInUserEmail = base64Decoding(sessionStorage.getItem(SESSIONSTORAGE.USER_EMAIL) || "");
  const loggedInUserFullname = base64Decoding(sessionStorage.getItem(SESSIONSTORAGE.USER_FULLNAME) || "");
  const loggedInUserAffiliation = base64Decoding(sessionStorage.getItem(SESSIONSTORAGE.USER_COMPANY_NAME) || "");


  return (
    <View
      style={{
        height: 91,
        paddingLeft: 20,
        justifyContent: "space-around",
        borderColor: "#dadee0",
        borderBottomWidth: 1,
        paddingTop: 10,
        paddingBottom: 10,
      }}
    >
      <Text
        style={{ color: "#333333", fontSize: 12, fontFamily: FONT.REGULAR }}
      >
        {loggedInUserEmail}
      </Text>
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <Text
          style={{ color: "#9ea0a5", fontSize: 12, fontFamily: FONT.REGULAR }}
        >
          {loggedInUserFullname}
        </Text>
        {loggedInUserAffiliation && (
          <View
            style={{
              alignItems: "center",
              justifyContent: "center",
              height: 24,
              paddingLeft: 10,
              paddingRight: 10,
              marginLeft: 10,
              borderRadius: 8,
              backgroundColor: "#0000000D",
            }}
          >
            <Text
              style={{
                color: "#8c8c8c",
                fontSize: 12,
                fontFamily: FONT.REGULAR,
              }}
            >
              {loggedInUserAffiliation}
            </Text>
          </View>
        )}
      </View>
    </View>
  );
}

interface profileProps {
  userRole: string;
  domainName: string;
  clickAccountInfoLinkButton: () => void;
  clickProjectLinkButton: () => void;
  clickLogoutButton: () => void;
}
// Root User Profile
function RootUserProfile(props: profileProps) {
  const { t } = useTranslation();
  return (
    <>
      <View
        style={{
          flexDirection: "row",
          height: 40,
          backgroundColor: "#465480",
          alignItems: "center",
          paddingLeft: 20,
          borderTopLeftRadius: 15,
          borderTopRightRadius: 15,
        }}
      >
        <RootUserIcon />
        <Text
          style={{
            color: "#ffffff",
            fontSize: 12,
            fontFamily: FONT.REGULAR,
            marginLeft: 5,
          }}
        >
          {props.userRole}
        </Text>
      </View>
      <CommonProfile />
      {/* 프로젝트 관리 */}
      <Pressable
        style={{
          flexDirection: "row",
          height: 40,
          alignItems: "center",
          paddingLeft: 20,
          borderColor: "#dadee0",
          borderBottomWidth: 1,
          backgroundColor: "#f2f5f7",
          paddingRight: 20,
        }}
        onPress={() => props.clickProjectLinkButton()}
      >
        <Text
          style={{
            flex: 60,
            color: "#8c9299",
            fontSize: 12,
            fontFamily: FONT.REGULAR,
          }}
        >
          {t("PROJECT_TEXT")}
        </Text>
        <Text
          style={{
            flex: 130,
            color: "#252525",
            fontSize: 12,
            fontFamily: FONT.REGULAR,
          }}
        >
          {t("PROFILE_PROJECT_DESCRIPTION_TEXT")}
        </Text>
        <RedirectGrayIcon />
      </Pressable>
      {/* 계정관리 */}
      <Pressable
        style={{
          flexDirection: "row",
          height: 40,
          alignItems: "center",
          paddingLeft: 20,
          borderBottomWidth: 1,
          borderBottomColor: "#dadee0",
        }}
        onPress={() => props.clickAccountInfoLinkButton()}
      >
        <AccountSettingImg />
        <Text
          style={{
            color: "#333333",
            fontSize: 12,
            fontFamily: FONT.REGULAR,
            marginLeft: 12,
          }}
        >
          {t("MENU_APPLICATION_ACCOUNT")}
        </Text>
      </Pressable>
      {/* 로그아웃 */}
      <Pressable
        style={{
          flexDirection: "row",
          height: 47,
          alignItems: "center",
          paddingLeft: 20,
        }}
        onPress={() => props.clickLogoutButton()}
      >
        <LogoutImg />
        <Text
          style={{
            color: "#8c8c8c",
            fontSize: 12,
            fontFamily: FONT.REGULAR,
            marginLeft: 12,
          }}
        >
          {t("LOGOUT_TEXT")}
        </Text>
      </Pressable>
    </>
  );
}
// Domain Admin Profile
function DomainAdministratorProfile(props: profileProps) {
  const { t } = useTranslation();
  return (
    <>
      <View
        style={{
          flexDirection: "row",
          height: 40,
          backgroundColor: "#64c6a4",
          alignItems: "center",
          paddingLeft: 20,
          borderTopLeftRadius: 15,
          borderTopRightRadius: 15,
        }}
      >
        <DomainAdminIcon />
        <Text
          style={{
            color: "#ffffff",
            fontSize: 12,
            fontFamily: FONT.REGULAR,
            marginLeft: 5,
          }}
        >
          {props.userRole}
        </Text>
      </View>
      <CommonProfile />
      {/* 계정관리 */}
      <Pressable
        style={{
          flexDirection: "row",
          height: 40,
          alignItems: "center",
          paddingLeft: 20,
          borderBottomWidth: 1,
          borderBottomColor: "#dadee0",
        }}
        onPress={() => props.clickAccountInfoLinkButton()}
      >
        <AccountSettingImg />
        <Text
          style={{
            color: "#333333",
            fontSize: 12,
            fontFamily: FONT.REGULAR,
            marginLeft: 12,
          }}
        >
          {t("MENU_APPLICATION_ACCOUNT")}
        </Text>
      </Pressable>
      {/* 프로젝트 관리 */}
      <Pressable
        style={{
          flexDirection: "row",
          height: 40,
          alignItems: "center",
          paddingLeft: 20,
          borderColor: "#dadee0",
          borderBottomWidth: 1,
          paddingRight: 20,
        }}
        onPress={() => props.clickProjectLinkButton()}
      >
        <RedirectIcon />
        <Text
          style={{
            color: "#333333",
            fontSize: 12,
            fontFamily: FONT.REGULAR,
            marginLeft: 12,
          }}
        >
          {t("PROJECT_MGMT_TITLE")}
        </Text>
      </Pressable>
      {/* 로그아웃 */}
      <Pressable
        style={{
          flexDirection: "row",
          height: 47,
          alignItems: "center",
          paddingLeft: 20,
        }}
        onPress={() => props.clickLogoutButton()}
      >
        <LogoutImg />
        <Text
          style={{
            color: "#8c8c8c",
            fontSize: 12,
            fontFamily: FONT.REGULAR,
            marginLeft: 12,
          }}
        >
          {t("LOGOUT_TEXT")}
        </Text>
      </Pressable>
    </>
  );
}
// Super Admin Profile
function SuperAdministratorProfile(props: profileProps) {
  const { t } = useTranslation();
  return (
    <>
      <View
        style={{
          flexDirection: "row",
          height: 40,
          backgroundColor: "#4f5fd8",
          alignItems: "center",
          paddingLeft: 20,
          borderTopLeftRadius: 15,
          borderTopRightRadius: 15,
        }}
      >
        <SuperAdminIcon />
        <Text
          style={{
            color: "#ffffff",
            fontSize: 12,
            fontFamily: FONT.REGULAR,
            marginLeft: 5,
          }}
        >
          {props.userRole}
        </Text>
      </View>
      <CommonProfile />
      {/* 계정관리 */}
      <Pressable
        style={{
          flexDirection: "row",
          height: 40,
          alignItems: "center",
          paddingLeft: 20,
          borderBottomWidth: 1,
          borderBottomColor: "#dadee0",
        }}
        onPress={() => props.clickAccountInfoLinkButton()}
      >
        <AccountSettingImg />
        <Text
          style={{
            color: "#333333",
            fontSize: 12,
            fontFamily: FONT.REGULAR,
            marginLeft: 12,
          }}
        >
          {t("MENU_APPLICATION_ACCOUNT")}
        </Text>
      </Pressable>
      {/* 프로젝트 관리 */}
      <Pressable
        style={{
          flexDirection: "row",
          height: 40,
          alignItems: "center",
          paddingLeft: 20,
          borderColor: "#dadee0",
          borderBottomWidth: 1,
          paddingRight: 20,
        }}
        onPress={() => props.clickProjectLinkButton()}
      >
        <RedirectIcon />
        <Text
          style={{
            color: "#333333",
            fontSize: 12,
            fontFamily: FONT.REGULAR,
            marginLeft: 12,
          }}
        >
          {t("PROJECT_MGMT_TITLE")}
        </Text>
      </Pressable>
      {/* 로그아웃 */}
      <Pressable
        style={{
          flexDirection: "row",
          height: 47,
          alignItems: "center",
          paddingLeft: 20,
        }}
        onPress={() => props.clickLogoutButton()}
      >
        <LogoutImg />
        <Text
          style={{
            color: "#8c8c8c",
            fontSize: 12,
            fontFamily: FONT.REGULAR,
            marginLeft: 12,
          }}
        >
          {t("LOGOUT_TEXT")}
        </Text>
      </Pressable>
    </>
  );
}

interface HeaderUserProfileProps {
  setLoading: Function;
  detectClictEventCb: Function;
}
function HeaderUserProfile(props: HeaderUserProfileProps) {
  // TODO 주석해제
  const loggedInUserEmail = base64Decoding(
    sessionStorage.getItem(SESSIONSTORAGE.USER_EMAIL) || ""
  );
  const userRole = base64Decoding(
    sessionStorage.getItem(SESSIONSTORAGE.USER_ROLE)
  );
  const loggedInUserFullname = base64Decoding(
    sessionStorage.getItem(SESSIONSTORAGE.USER_FULLNAME) || ""
  );

  const navigate = useNavigate();

  const [executeLogoutYn, setExecuteLogoutYn] = useState(false);
  const divRef = useRef(null);

  useEffect(() => {
    window.addEventListener("click", detectClickEvent);
    return () => {
      window.removeEventListener("click", detectClickEvent);
    };
  }, []);

  useEffect(() => {
    if (executeLogoutYn) {
      executeLogout();
    }
  }, [executeLogoutYn]);

  function detectClickEvent(event) {
    props.detectClictEventCb(event, divRef);
  }

  function executeLogout() {
    props.setLoading(true);
    const postData = {};
    requests
      .post(PLATFORM_URL.LOGOUT, postData)
      .then((response) => {
        clearSessionStorage();
        props.setLoading(false);
        setExecuteLogoutYn(false);
        navigate(`${PAGE_URL.LOGIN}`);
      })
      .catch((error) => {
        clearSessionStorage();
        props.setLoading(false);
        setExecuteLogoutYn(false);
        navigate(`${PAGE_URL.LOGIN}`);
      });
  }

  function clickAccountInfoLinkButton() {
    navigate(`${PAGE_URL.APPLICATION_MY_INFO}`);
  }

  function clickProjectLinkButton() {
    navigate(`${PAGE_URL.APPLICATION_PROJECT}`);
  }

  function clickLogoutButton() {
    setExecuteLogoutYn(true);
  }

  return (
    <View style={style.topContainer} ref={divRef}>
      <div style={className.backgroundContainer}>
        {userRole === "GST" ? (
          <RootUserProfile
            userRole={'게스트'}
            domainName={loggedInUserEmail}
            clickAccountInfoLinkButton={clickAccountInfoLinkButton}
            clickProjectLinkButton={clickProjectLinkButton}
            clickLogoutButton={clickLogoutButton}
          />
        ) : userRole === "USR" ? (
          <DomainAdministratorProfile
            userRole={'사용자'}
            domainName={loggedInUserEmail}
            clickAccountInfoLinkButton={clickAccountInfoLinkButton}
            clickProjectLinkButton={clickProjectLinkButton}
            clickLogoutButton={clickLogoutButton}
          />
        ) : userRole === "ADM" ? (
          <SuperAdministratorProfile
            userRole={'관리자'}
            domainName={loggedInUserEmail}
            clickAccountInfoLinkButton={clickAccountInfoLinkButton}
            clickProjectLinkButton={clickProjectLinkButton}
            clickLogoutButton={clickLogoutButton}
          />
        ) : null}
      </div>
    </View>
  );
}

export default HeaderUserProfile;

const style = StyleSheet.create({
  topContainer: {
    zIndex: 10,
  },
  emailContainer: {
    height: 50,
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderBottomColor: "#dadee0",
    alignItems: "center",
    justifyContent: "center",
  },
  emailValue: {
    fontFamily: "NotoSansKR-Medium",
    fontSize: 11,
    letterSpacing: -0.5,
    color: "#4d5367",
  },
});

const className = {
  backgroundContainer: {
    position: "absolute",
    width: "250px",
    top: "-2px",
    right: "20px",
    borderRadius: "15px",
    boxShadow: "0 6px 10px 0 rgba(79, 95, 216, 0.3)",
    backgroundColor: "#fff",
  } as CSSProperties,
};
